





















import Vue from 'vue'
import Input from '@/components/shared/atoms/Input'
import FormBlock from '@/components/shared/molecules/Form/FormBlock'
import FormWrapper from '@/components/shared/organisms/FormWrapper'
import PWResetRequestValidator, { Fields, FieldErrors } from '@/utils/validators/form/Auth/PWResetRequest'
import { extractTargetFields } from '@/utils/helper'
import RequestPWResetUseCase from '@/usecases/auth/RequestPWResetUseCase'

interface IData {
  fields: Fields
  enableCheckFlg: { [key in keyof Fields]: boolean }
  sentRequest: boolean
}

export default Vue.extend({
  components: {
    FormBlock,
    FormWrapper,
    Input
  },
  props: {
    // Only for dev use like showing stories
    devProps: {
      type: Object as () => {
        showError?: boolean
        fullfilled?: boolean
        requestSent?: boolean
      },
      default: null
    }
  },
  data(): IData {
    return {
      fields: {
        email: ''
      },
      enableCheckFlg: {
        email: false
      },
      sentRequest: false
    }
  },
  computed: {
    formErrors(): FieldErrors {
      const targetFields = extractTargetFields(this.fields, this.enableCheckFlg)

      return PWResetRequestValidator.validate(targetFields)
    },
    isFullfilled(): boolean {
      // TODO: 要改善
      const { email } = this.fields
      if (email === '') return false

      return true
    },
    canRequestPWReset(): boolean {
      const hasErrors = Object.values(this.formErrors).some(field => field.length !== 0)
      return this.isFullfilled && !hasErrors
    }
  },
  mounted() {
    const devProps = this.devProps
    if (devProps) {
      if (devProps.showError) {
        this.fields = {
          ...this.fields,
          email: 'some rondom error'
        }
        this.enableCheckFlg = {
          ...this.enableCheckFlg,
          email: true
        }
      }
      if (devProps.fullfilled) {
        this.fields = {
          ...this.fields,
          email: 'shin.ando@photocreate.co.jp'
        }
        this.enableCheckFlg = {
          ...this.enableCheckFlg,
          email: true
        }
      }
      if (devProps.requestSent) {
        this.sentRequest = true
      }
    }
  },
  methods: {
    enableCheck(str: keyof Fields) {
      this.enableCheckFlg[str] = true
    },
    async requestPWReset() {
      // Enable all validation flg
      Object.keys(this.fields).forEach(field => this.enableCheck(field as keyof Fields))

      if (!this.canRequestPWReset) return

      const usecase = new RequestPWResetUseCase({
        snapsnapGateway: this.$snapsnapGateway
      })
      const params = this.fields
      try {
        await usecase.execute(params)
        this.sentRequest = true
      } catch (e) {
        this.sentRequest = true
      }
    }
  }
})
